import React from 'react';
import { Button } from '@fluentui/react-components';
import { ArrowLeftRegular } from '@fluentui/react-icons';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { iconButtonStyles } from '../../app/common/styles/CommonStyleObjects';
import { getParentUriSegment } from '../../utils/Helpers';

interface IBackButtonProps {
  ariaLabel: string;
  children: React.ReactNode;
  backDepth?: number;
  goToUrl?: string;
}

const BackButton = ({ ariaLabel, children, backDepth, goToUrl }: IBackButtonProps): JSX.Element => {
  const history = useHistory();
  const match = useRouteMatch();

  const retrieveUrl = (depth = 1) => {
    if (goToUrl) {
      return goToUrl;
    }
    let newUrl = match.url;
    for (let i = 0; i < depth; i += 1) {
      newUrl = getParentUriSegment(newUrl);
    }
    return newUrl;
  };

  return (
    <>
      <Button
        appearance="subtle"
        icon={<ArrowLeftRegular color={iconButtonStyles.color} />}
        style={{ marginRight: 10 }}
        title={ariaLabel}
        aria-label={ariaLabel}
        onClick={(): void => {
          history.push(retrieveUrl(backDepth));
        }}
      />
      {children}
    </>
  );
};

export default BackButton;
